export const EVENT_VIEWS = {
  CALENDAR: 'calendar',
  LIST: 'list',
}

export const DEFAULT_EVENT_VIEW = EVENT_VIEWS.CALENDAR



// WEBPACK FOOTER //
// ./src/modules/events/domain/data/view.js